import { ValuableNode } from '../../models/ValuableNode'

export class SchemaDynamicNode extends ValuableNode {}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Dynamic': SchemaDynamicNode
  }
}
